module.exports = __webpack_public_path__ + "img/logo2.1be8a5e2.png";